var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFreedom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 77.2,
    height: 77.2,
    viewBox: "0 0 77.2 77.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#ff5079;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M2.262,173.617H13.949a11.328,11.328,0,0,0,11.081,9.047H31a2.262,2.262,0,0,0,2.231-1.89l1.508-9.047a2.262,2.262,0,0,0-2.231-2.634H27.291V164.57h8.231a2.262,2.262,0,0,0,2.231-1.89l1.508-9.047A2.262,2.262,0,0,0,37.03,151h-12a11.328,11.328,0,0,0-11.081,9.047H2.262A2.262,2.262,0,0,0,0,162.309v9.047a2.262,2.262,0,0,0,2.262,2.262Zm27.575,0-.754,4.523H25.03a6.8,6.8,0,0,1-6.4-4.523ZM25.03,155.523h9.33l-.754,4.523H18.634A6.8,6.8,0,0,1,25.03,155.523ZM4.523,164.57H22.768v4.523H4.523Z",
    transform: "translate(0 -128.232)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M288.44,160.047H276.753A11.328,11.328,0,0,0,265.672,151H259.7a2.262,2.262,0,0,0-2.231,1.89l-1.508,9.047a2.262,2.262,0,0,0,2.231,2.634h5.215v4.523H255.18a2.262,2.262,0,0,0-2.231,1.89l-1.508,9.047a2.262,2.262,0,0,0,2.231,2.634h12a11.328,11.328,0,0,0,11.081-9.047H288.44a2.262,2.262,0,0,0,2.262-2.262v-9.047A2.262,2.262,0,0,0,288.44,160.047Zm-27.575,0,.754-4.523h4.053a6.8,6.8,0,0,1,6.4,4.523Zm4.807,18.094h-9.33l.754-4.525h14.973A6.8,6.8,0,0,1,265.672,178.141Zm20.506-9.047H267.934V164.57h18.245Z",
    transform: "translate(-213.502 -128.232)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M323.914,412.957a2.262,2.262,0,0,0,.828-3.09l-4.523-7.835a2.262,2.262,0,0,0-3.918,2.262l4.523,7.835A2.262,2.262,0,0,0,323.914,412.957Z",
    transform: "translate(-268.351 -340.452)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M137.129,29.435a2.262,2.262,0,0,0-.828,3.09l4.523,7.835a2.262,2.262,0,1,0,3.917-2.262l-4.523-7.835A2.261,2.261,0,0,0,137.129,29.435Z",
    transform: "translate(-115.492 -24.739)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M140.824,402.031l-4.523,7.835a2.262,2.262,0,0,0,3.918,2.262l4.523-7.835a2.262,2.262,0,0,0-3.918-2.262Z",
    transform: "translate(-115.491 -340.452)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M320.825,30.262,316.3,38.1a2.262,2.262,0,1,0,3.917,2.262l4.523-7.835a2.262,2.262,0,1,0-3.917-2.262Z",
    transform: "translate(-268.351 -24.738)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M241,423.262v9.2a2.262,2.262,0,0,0,4.523,0v-9.2a2.262,2.262,0,0,0-4.523,0Z",
    transform: "translate(-204.662 -357.521)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M241,2.262v9.2a2.262,2.262,0,0,0,4.523,0v-9.2a2.262,2.262,0,0,0-4.523,0Z",
    transform: "translate(-204.662)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreedom);
export default __webpack_public_path__ + "static/media/freedom.828a51d965b95f17f8bfba0da110980c.svg";
export { ForwardRef as ReactComponent };